export default __webpack_public_path__ + "static/media/calculator-icon.9de3cdbd.svg";